import { Component } from '@angular/core';

@Component({
  selector: 'app-marketing-requests',
  templateUrl: './marketing-requests.component.html',
  styleUrl: './marketing-requests.component.scss',
})
export class MarketingRequestsComponent {
  selectedTabIndex = 0;

  openAllocationTab(): void {
    this.selectedTabIndex = 1;
  }
}
